import Vue from "vue";
import VTooltip from "v-tooltip";
import App from "./App.vue";
import Meta from "vue-meta";
import router from "./router";
import vClickOutside from "v-click-outside";
import VueAwesomeSwiper from "vue-awesome-swiper";
import "@/filters";
import store from "./store";
import "swiper/css/swiper.css";
import "@/css/main.scss";
import mixins from "@/mixins/index";
import inject from "@/plugins/inject";

Vue.use(Meta);
Vue.use(VTooltip);
Vue.use(vClickOutside);
Vue.use(VueAwesomeSwiper);
Vue.mixin(mixins);

Vue.config.productionTip = false;

Vue.use(inject);

import "@/components/md-ui.js";

new Vue({
  router,
  store,
  render: h => h(App),
  mounted: () => document.dispatchEvent(new Event("x-app-rendered"))
}).$mount("#app");
